import { searchTabs } from '@packages/tabs/lib/common';
import { find } from 'lodash';
import { useContext } from 'react';
import { Context } from './context';
import { TabObject } from './TabContainer';

export interface TabsResponse {
    index: number;
    tabs: TabObject[];
    url: string | null;

    current: TabObject | null;

    setIndex(index: number): void;

    setMounted(index: number): void;

    setTab(tab: any): void;

    setTabs(tabs: string[] | TabObject[]): void;

    nextTab(): void;

    previousTab(): void;

    prevTab(): void;

    search(tab: string | number | TabObject): TabObject | null;

    isActive(tab: string | number | TabObject): boolean;
}

export function useTabs(): TabsResponse {
    const [state, actions] = useContext(Context);

    const index = state.get('index');
    const current = find(state.get('tabs'), ['index', index]) ?? null;

    /**
     * Search tab by index, name or object
     * @param tab
     * @returns {TabObject}
     */
    const search = (tab: string | number | TabObject): TabObject | null => searchTabs(state.get('tabs'), tab);

    /**
     * Check if given tab it's active one
     * @param tab
     * @returns {boolean}
     */
    const isActive = (tab: string | number | TabObject): boolean => {
        tab = search(tab) as TabObject;

        return (
            !!tab &&
            !!current &&
            (tab === current ||
                tab.index === index ||
                tab.index === current.index ||
                tab.name === current.name ||
                tab.label === current.label)
        );
    };

    return {
        index,
        current,
        search,
        isActive,
        tabs: state.get('tabs'),
        url: state.get('url'),
        prevTab: actions.previousTab,
        ...actions,
    };
}
